import React from 'react';
const cn = require('classnames');

export default class LoginForm extends React.Component {

    constructor(props) {
        super(props);
        this.handleSubmit = (event) => this._handleSubmit(event);
    }

    _handleSubmit(event) {
        event.preventDefault();
        const email = this.refs.email.value;
        const password = this.refs.password.value;
        this.props.login(email, password);
    }

    render() {
        const fieldErrors = this.props.session.fieldErrors || {};
        return (
            <form ref="loginForm" onSubmit={this.handleSubmit}>
                <fieldset>
                    <legend className="text-xs-center text-primary">
                        Iniciar sesión
                    </legend>
                    <div className={cn('form-group', {'has-danger' : (fieldErrors.email || []).length})}>
                        <label htmlFor="email" className="control-label">
                            Correo electrónico
                        </label>
                        <input type="email" className="form-control" ref="email" />
                        {
                            (fieldErrors.email || []).map((error, i) => {
                                return (
                                    <div key={i} className="form-control-feedback">{error}</div>
                                );
                            })
                        }
                    </div>
                    <div className="form-group">
                        <label htmlFor="password" className="control-label">
                            Contraseña
                        </label>
                        <input type="password" className="form-control" ref="password"/>
                    </div>
                    <div className="text-xs-center">
                        <button className="btn btn-primary" disabled={this.props.session.isPosting}>
                            {this.props.session.isPosting ? (<span><i className="fa fa-spinner fa-spin"></i> Cargando</span>): <span>Iniciar sesión</span>}
                        </button>
                    </div>
                </fieldset>
            </form>
        );
    }
}


/** WEBPACK FOOTER **
 ** ./src/components/presentation/LoginForm.jsx
 **/